import { initializeApp } from 'firebase/app'

const firebaseConfig =
  import.meta.env.VITE_FIREBASE_ENV === 'production'
    ? {
        apiKey: 'AIzaSyAmRzcBGrsHOHsVK6Y7tXrI3xjxd87i0FU',
        authDomain: 'lvbl-716ca.firebaseapp.com',
        projectId: 'lvbl-716ca',
        storageBucket: 'lvbl-716ca.firebasestorage.app',
        messagingSenderId: '667457871370',
        appId: '1:667457871370:web:efb4f6d27f5945c47d49f3',
        measurementId: 'G-XEFFBTT8EY',
      }
    : {
        apiKey: 'AIzaSyBHOazSTv8tHz0y0xGIrkqD4jBbBwm4maI',
        authDomain: 'lvbl-staging.firebaseapp.com',
        projectId: 'lvbl-staging',
        storageBucket: 'lvbl-staging.appspot.com',
        messagingSenderId: '890311262243',
        appId: '1:890311262243:web:eb168d63e6241d45977196',
      }

const firebase = initializeApp(firebaseConfig)

export default firebase
